import shirt from './shirt.png';

const items2 = [
  {
    title: 'Garment Study',
    subtitle: 'Archived Heavyweight Cotton Sample',
    image: shirt,
  },
];

export default items2;
